// utils/fx.js

async function getRate(from, to, dateISO) {
  try {
    // Nova API v2 tem endpoints diferentes
    let url;
    
    if (dateISO && dateISO !== "latest") {
      // Para datas específicas, usar endpoint /rates com parâmetro date
      url = `https://api.frankfurter.dev/v2/rates?base=${encodeURIComponent(
        from
      )}&quotes=${encodeURIComponent(to)}&date=${dateISO}`;
    } else {
      // Para taxa mais recente, usar endpoint /rate/{base}/{quote}
      url = `https://api.frankfurter.dev/v2/rate/${encodeURIComponent(
        from
      )}/${encodeURIComponent(to)}`;
    }

    const res = await fetch(url, { cache: "no-store" });

    if (!res.ok) {
      console.error("FX HTTP error:", res.status, res.statusText);
      return 0;
    }

    const data = await res.json();
    
    // Nova API retorna estrutura diferente
    if (dateISO && dateISO !== "latest") {
      // Endpoint /rates retorna array
      // Encontrar o par correto no array
      const rateObj = Array.isArray(data) 
        ? data.find(r => r.base === from && r.quote === to)
        : null;
      return Number(rateObj?.rate || 0);
    } else {
      // Endpoint /rate/{base}/{quote} retorna objeto único
      return Number(data?.rate || 0);
    }
  } catch (error) {
    console.error("FX network error:", error);
    return 0;
  }
}

export async function fetchFxRates(dateISO) {
  const [usdBrl, eurBrl] = await Promise.all([
    getRate("USD", "BRL", dateISO),
    getRate("EUR", "BRL", dateISO),
  ]);

  return {
    BRL: 1,
    USD: usdBrl ? 1 / usdBrl : 0,
    EUR: eurBrl ? 1 / eurBrl : 0,
    USD_BRL: usdBrl || 5.2,
    EUR_BRL: eurBrl || 5.6,
  };
}

export function sumByCurrency(rows) {
  return rows.reduce(
    (acc, r) => {
      const c = (r.currency || r.currency_code || "BRL").toUpperCase();
      const amt = Number(r.amount) || 0;
      if (c === "USD") acc.usd += amt;
      else if (c === "EUR") acc.eur += amt;
      else acc.brl += amt;
      return acc;
    },
    { usd: 0, eur: 0, brl: 0 }
  );
}

export function toBRLTotal(totals, rates) {
  if (!rates) return 0;
  return (
    (Number(totals?.brl) || 0) +
    (Number(totals?.usd) || 0) * (Number(rates.USD_BRL) || 0) +
    (Number(totals?.eur) || 0) * (Number(rates.EUR_BRL) || 0)
  );
}